// extracted by mini-css-extract-plugin
export default {"form":"Rk0NxDdfPxidrKlxXGbA","bottom":"K9vB3qZFvSuk6dpwWeMg","subrow":"R8vlaDNShe9JhN_AAtz2","box":"CNfdqhyvCGfxf_1fAlV4"};